import { z } from 'zod'

export const occasionIdSchema = z.enum([
  'aniversario',
  'namorados',
  'casamento',
  'maternidade',
  'condolencias',
  'corporativo',
  'sem-motivo',
])

export type OccasionId = z.infer<typeof occasionIdSchema>

export const occasionSchema = z.object({
  id: occasionIdSchema,
  title: z.string().min(1),
  emotionalHeadline: z.string().min(1),
  description: z.string().min(1),
  conciergeSubcopy: z.string().min(1),
  seoTitle: z.string().min(1),
  seoDescription: z.string().min(1),
})

export type Occasion = z.infer<typeof occasionSchema>
